import * as angular from "angular";
import * as _ from "lodash";
import {SitesRequestsService} from "../sites/services/sites-requests.service";
import {BranchModel} from "../branches/models/branch.model";
import {PoliciesRequestsService} from "./services/policies-requests.service";
import {GroupModel} from "../groups/models/group.model";
import {ADMIN_USERS_IMPORT_CONFIG} from "./constants/admin-users-import.const";

angular
  .module('bringoz.admin.policies')
  .config(policiesConfig);

/* @ngInject */
function policiesConfig($stateProvider) {

  $stateProvider

    .state('policy', {
      parent: 'bringoz.site',
      url: '/policy',
      abstract: true,
      template: '<policy-view></policy-view>'
    })

    .state('self-profile', {
      parent: 'bringoz.site',
      url: '/profile/me',
      pageTrack: '/policy/user/info',
      template: '<self-profile user="vm.user" email-report-notification-configurations="vm.emailReportNotificationConfigurations"></self-profile>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, profileData, site) {
        this.user = profileData.user;
        this.emailReportNotificationConfigurations = profileData.emailReportNotificationConfigurations || [];

        const user = profileData.user;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: user.firstName + ' ' + user.lastName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Profile"});

      },
      resolve: {
        profileData: function (IamRequests, UserService, site, $q) {
          // Get the current user's ID
          const currentUser = UserService.getCurrentUser();
          if (!currentUser || !currentUser.id) {
            return $q.reject('User not logged in');
          }
          return IamRequests.getSelfProfile(currentUser.id, site.id)
            .catch(function(error) {
              console.error('Failed to load user profile:', error);
              return $q.reject(error);
            });
        }
      }
    })

    .state('policy.users', {
      url: '/users',
      template: '<policy-users-view extended-policy="vm.extendedPolicy" site-id="vm.siteId"></policy-users-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, site) {

        this.extendedPolicy = extendedPolicy;
        this.siteId = site.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Users Management'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
          return sitesRequestsService.getSitePolicy(site.id);
        }
      }
    })

    // Upload Admin Users View - a sibling of 'policy.users', not a child of the abstract 'policy'
    // state, which renders the configurations tab strip.
    .state('policy-users-upload', {
      parent: 'bringoz.site',
      url: '/policy/users-upload',
      controllerAs: 'vm',
      template: '<admin-users-import-view permission permission-only="vm.permissions" ' +
        'site-id="vm.siteId"></admin-users-import-view>',
      controller: function (triBreadcrumbsService, $state, site, IAMPermissions) {
        const permissions = ADMIN_USERS_IMPORT_CONFIG.permissions;
        const hasImportPermission = _.some(permissions, (permission: string) => IAMPermissions.hasPermission(permission));

        if (!hasImportPermission) {
          $state.go('policy.users');
          return;
        }

        this.permissions = permissions;
        this.siteId = site.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Import Admin Users'});
        triBreadcrumbsService.addCrumb({name: 'Users Management', state: 'policy.users'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    .state('policy.service-accounts', {
      url: '/service-accounts',
      template: '<policy-service-accounts-view extended-policy="vm.extendedPolicy" site-id="vm.siteId"></policy-service-accounts-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, site) {

        this.extendedPolicy = extendedPolicy;
        this.siteId = site.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'API Keys'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
          return sitesRequestsService.getSitePolicy(site.id);
        }
      }
    })

    .state('policy.password', {
      url: '/password',
      template: '<policy-password-view extended-policy="vm.extendedPolicy" site-id="vm.siteId"></policy-password-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, site) {

        this.extendedPolicy = extendedPolicy;
        this.siteId = site.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Password Policy'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
          return sitesRequestsService.getSitePolicy(site.id);
        }
      }
    })

    .state('policy.token', {
      url: '/token',
      template: '<policy-token-view extended-policy="vm.extendedPolicy" site-id="vm.siteId"></policy-token-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, site) {

        this.extendedPolicy = extendedPolicy;
        this.siteId = site.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Token Policy'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
          return sitesRequestsService.getSitePolicy(site.id);
        }
      }
    })

    .state('policy.user', {
      url: '/users/:userId',
      abstract: true,
      template: '<admin-user-view tabs="tabs"></admin-user-view>',
      controller: function ($scope) {
        $scope.tabs = ['info', 'branches', 'teams'];
      }
    })

    .state('policy.user.info', {
      url: '/info',
      pageTrack: '/policy/user/info',
      template: '<admin-user-info user="vm.user" extended-policy="vm.extendedPolicy" site-id="vm.siteId" ' +
        'email-notification-configurations="vm.emailNotificationConfigurations" user-branches="vm.userBranches" user-teams="vm.userTeams"></admin-user-info>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, user, extendedPolicy, emailNotificationConfigurations, userBranches, userTeams, site) {

        this.user = user;
        this.userBranches = userBranches;
        this.userTeams = userTeams;
        this.extendedPolicy = extendedPolicy;
        this.siteId = site.id;
        this.emailNotificationConfigurations = emailNotificationConfigurations.emailReportNotificationConfigurations;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: user.firstName + ' ' + user.lastName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Users Management', state: 'policy.users'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});

      },
      resolve: {
        extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
          return sitesRequestsService.getSitePolicy(site.id);
        },
        user: function (extendedPolicy, $stateParams) {
          return _.find(extendedPolicy.users, function (user) {
            return user.id === $stateParams.userId
          });
        },
        emailNotificationConfigurations: function (policiesRequestsService: PoliciesRequestsService, extendedPolicy, user, site) {
          return policiesRequestsService.getUserReports(extendedPolicy.policy.id, user.id, undefined, site.id);
        },
        userBranches: function (IamRequests, $groups, site, user) {
          if (!!user.groupIdsMap) {
            const groupIds = user.groupIdsMap[site.id];
            return $groups().$asyncValues(groupIds)
              .then((groups: GroupModel[]) => {
                return _.uniq(_.compact(_.flatMap(groups, 'branchReferences')));
              });
          } else {
            return IamRequests.getUserBranches(site.id, user.id);
          }
        },
        userTeams: function (teamsRequestsService, user, site) {
          return teamsRequestsService.getTeamMembersByUser(user.id);
        }
      }
    })

    .state('policy.user.branches', {
      url: '/branches',
      pageTrack: '/policy/user/branches',
      template: '<admin-branches user="$resolve.user" branch-ids="$resolve.branches" policy-id="$resolve.extendedPolicy.policy.id"></admin-branches>',
      controller: function ($scope, extendedPolicy, user, branches, triBreadcrumbsService) {
        $scope.tabs = ['info', 'branches'];

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: user.firstName + ' ' + user.lastName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Users Management', state: 'policy.users'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
          return sitesRequestsService.getSitePolicy(site.id);
        },
        user: function (extendedPolicy, $stateParams) {
          return _.find(extendedPolicy.users, function (user) {
            return user.id === $stateParams.userId
          });
        },
        branches: function (IamRequests, site, user) {
          return IamRequests.getUserBranches(site.id, user.id)
            .then(function (branches: BranchModel[]) {
              return _.map(branches, 'id');
            });
        }
      }
    })

    .state('policy.user.teams', {
      url: '/teams',
      template: '<teams-view teams="$resolve.teams" member-id="$resolve.user.id"></teams-view>',
      controller: function (user, teams, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: user.firstName + ' ' + user.lastName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Users Management', state: 'policy.users'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
          return sitesRequestsService.getSitePolicy(site.id);
        },
        user: function (extendedPolicy, $stateParams) {
          return _.find(extendedPolicy.users, function (user) {
            return user.id === $stateParams.userId
          });
        },
        teams: function (IamRequests, site, user) {
          return IamRequests.getUserTeams(site.id, user.id)
        }
      }
    })

    .state('policy.groups', {
      url: '/groups',
      template: '<roles-groups extended-policy="vm.extendedPolicy" site-id="vm.siteId"></roles-groups>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, site) {

        this.extendedPolicy = extendedPolicy;
        this.siteId = site.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Groups'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});

      },
      resolve: {
        extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
          return sitesRequestsService.getSitePolicy(site.id);
        }
      }
    });

}
